module.exports = __webpack_public_path__ + "static/img/idCarC.915d7fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/idCarC.png
// module id = KJIt
// module chunks = 1